import React from "react";

const Gonglo = () => {
  return (
    <div className="gonglo detail">
      <p className="tit">
        한국영화공로상은 한국영화에 대한 전세계적 대중화의 중요성을 인식하여
        한국영화를 국제영화계에 널리 소개하는데 기여한 인물에게 수여된다. 올해는
        뉴욕아시아영화제 공동창립자이자 큐레이터 및 작가로서 지난 20년간
        한국영화를 알려온 고란 토팔로빅을 선정하였다.
      </p>
      <div className="inner">
        <img src={process.env.PUBLIC_URL + "../images/gonglo.jpg"} alt="" />
        <div className="textbox">
          <span className="name">고란 토팔로빅</span>
          <span className="detail">미국 | 뉴욕아시아영화제 前 집행위원장</span>
          <p>
            고란 토팔로빅은 지난 20년간 미국에서 영화제 기획, 큐레이터, 작가로서
            한국영화를 알리는 데 기여했다. 그는 1999년 미국에서 최초로
            한국영화를 조명한 비영리 예술문화단체 ‘서브웨이 시네마’를 창립했으며
            이사회 임원으로 활동했다. 또한, 뉴욕아시아영화제 공동 창립자이자
            프로그래머, 그리고 前 집행위원장인 고란 토팔로빅은 14년간 100편
            이상의 한국영화를 소개하는 등 한국영화가 뉴욕아시아영화제 프로그램의
            한 축이 될 수 있도록 하였다. 이외에도 최민식, 이정재 등 국내 유명
            배우의 회고전과 박찬욱, 봉준호 등 감독과의 대화를 진행하며, 한국영화
            산업을 알리는 데 힘썼다. 최근에는 『끊임없는 발명: 새로운 한국 영화,
            1996-2003 회고전』을 개최하였으며, 방송 『새로운 한국 영화』
            시리즈의 큐레이터를 맡았다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gonglo;
